// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import AdvisoryServicesPage from "../pages/AdvisoryServices/AdvisoryServices";
const __wvcRoutePaths = ["/AdvisoryServicesPage", "/advisory-services"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["advisory-services", "advisoryservicespage", "bpv-investmentcriteria-page", "bpvinvestmentcriteriapage", "capital-raises", "capitalraisespage", "contact", "contactpage", "growth-go-to-market-strategy", "growthgotomarketstrategypage", "home", "homepage", "insights", "insightspage", "m-a-advisory-services", "mergersandacquisitionsadvisoryservicespage", "our-story", "ourstorypage", "post", "regulatory-disclosures", "regulatorydisclosurespage", "strategic-advisory", "strategicadvisorypage", "team", "teampage", "transactions", "transactionspage", "value-builder-assessment-is-your-business-pe-ready", "valuebuilderassessmentisyourbusinesspereadypage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<AdvisoryServicesPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<AdvisoryServicesPage />} />
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
